const DropdownMenuDivider = () => (
  <div style={{ height: 1 }} className="w-full my-1 bg-gray-200" />
);

export default DropdownMenuDivider;
